// extracted by mini-css-extract-plugin
export default {"wrapper":"_cde1c573","content":"_843aa3a9","header":"_fec1a79f","viewMoreButtonWrapper":"_d14bdbfd","viewMoreButton":"_32169eee"};